import React, { Component } from 'react';
import { connect } from 'react-redux';
import { saveProduct, getProduct, getProductTypes, getWeightSettings, getPriceMatrices, getTaxesRate, getCategories, editProductUPC, clearProductTypeList } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { initializeProductForm, loadProductPriceMatrixTable, clearStoreProductForType, formInput, clearFormInput } from 'actions/FormActions';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import DecimalInputProductSKU from 'screens/components/basic/DecimalInputProductSKU';
import SelectInput from 'screens/components/basic/SelectInput';
import ImageUpload from 'screens/components/basic/ImageUpload';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import DialogHeader from 'screens/components/basic/DialogHeader';
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
import GenericTable from 'screens/components/advanced/GenericTable';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';

import LOOKUP from 'constants/lookup';

import { selectProductModel } from 'selectors/entitySelector';
import PriceMatrixMeasurementTable from '../priceMatrix/PriceMatrixMeasurementTable';
import util from 'library/util';
import { MeasurementType } from 'constants/enums';
import { productEditCrumb, productAddCrumb } from 'utils/breadcrumbInfo';
import { Link } from 'react-router-dom';
import ProductCategorySave from '../productCategory/ProductCategorySave';
import ProductUPCEdit from './ProductUPCEdit';

import ProductMood from './Components/ProductMood';
import ProductTerpene from './Components/ProductTerpene';
import MoodDialogInput from './Components/MoodDialogInput';
import TerpeneDialogInput from './Components/TerpeneDialogInput';
import MinorCanabinoidDialogInput from './Components/MinorCanabinoidDialogInput';
import ProductMinorCanabinoid from './Components/ProductMinorCanabinoid';
import ToggleButtonsGroup from './Components/ToggleButtonsGroup';
import ProductManualUPC from './ProductManualUPC';
import WithRouter from 'custom/withRouter';
import { Col } from 'react-bootstrap';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import MultipleImageUpload from './Components/MultipleImageUpload';

const customContentStyle = {
    width: '95%',
    maxWidth: 'none'
};

const pageName = "ProductSave";

class ProductSave extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: "",
            priceLoaded: false,
            categoryDialogOpen: false,
            editUPCDialogOpen: false,
            manualUPCDialogOpen: false,
            barcode: "",
            quantity: "",
            productName: "",
            store: "",
            //this value is for tabs
            value: 'productProfile',
            weightInOneUnitShowing: true,
            productSuppliers: [],
            price: "",
            manageMoodsDialogOpen: false,
            manageTerpenesDialogOpen: false,
            manageMinorCanabinoidsDialogOpen: false
        };
        this.ws = null;
        this.closeCategoryForm = this.closeCategoryForm.bind(this);
        this.closeEditUPCForm = this.closeEditUPCForm.bind(this);
    }

    componentWillMount() {
        // load list types with categories
        this.props.getProductTypes();
        this.props.getWeightSettings();
        this.props.getTaxesRate();

        const productId = this.props.params && this.props.status !== "add" ? this.props.params.id : 0;
        //if true dispatch an action to retrive doctor data from API and set Status to EDIT
        if (productId) {
            this.setState({ status: "EDIT" });
            this.props.getProduct(productId, this.props.branchId);
        }
        //if false dispatch an action to clean the form and set default values, Status to ADD
        else {
            this.setState({ status: "ADD" });
            this.props.init(pageName);
            this.props.clearFormInput(`${pageName}BaseCost`);
        }
        try {
            this.initWebSocket();
        }
        catch (err) {
            this.initWebSocket();
        }
    }

    //check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess) || (newProps.saveError != undefined && newProps.saveError !== this.props.saveError)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }

        if (newProps.productModel) {
            if (newProps.productModel.PriceMatrixId && (newProps.priceMatrices || this.props.priceMatrices != newProps.priceMatrices) && (this.props.productModel.PriceMatrixId !== newProps.productModel.PriceMatrixId || !this.state.priceLoaded)) {
                const priceMatrix = newProps.priceMatrices.filter((item) => item.id === newProps.productModel.PriceMatrixId)[0];
                this.props.loadProductPriceMatrixTable(priceMatrix);
                this.setState({ priceLoaded: true });
            }

            if (!isNaN(this.props.productModel.TypeId) && !isNaN(newProps.productModel.TypeId)
                && this.props.productModel.TypeId !== newProps.productModel.TypeId && this.props.productModel.TypeId !== 0 && newProps.productModel.TypeId !== 0 && newProps.productModel.TypeId == 2) {
                this.props.clearStoreProductForType();
            }
        }

        if (newProps.productModel.TypeId === 2 && newProps.productModel.CategoryId && (newProps.productModel.CategoryId !== this.props.productModel.CategoryId) && newProps.productTypes.length > 0) {
            const selectedCategoryType = newProps.productTypes.filter(item => item.measurementType == newProps.selectedType)[0];
            const selectedCategory = selectedCategoryType.categories.find(item => item.id == newProps.productModel.CategoryId);
            if (selectedCategory) {
                this.setState({
                    weightInOneUnitShowing: !selectedCategory.isCannabis ? false : true
                })
            }
        }

        if (newProps.productGotSuccessKey != null && newProps.productGotSuccessKey != undefined && newProps.productGotSuccessKey != this.props.productGotSuccessKey) {
            this.closeEditUPCForm();
        }

        if (newProps.isMedical != undefined && newProps.isMedical !== this.props.isMedical && newProps.isMedical) {
            this.props.getPriceMatrices();
        }
    }

    componentDidMount = () => {
        if (this.props.isLegal && !this.props.isMedical) {
            this.props.formInput(2, pageName + `TypeId`);
        }

        if (this.props.isMedical) {
            this.props.getPriceMatrices();
        }
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.syncProductSuccess === null && this.props.syncProductSuccess !== null) || prevProps.syncProductSuccess !== this.props.syncProductSuccess) {
            const productId = this.props.params ? this.props.params.id : 0;
            if (productId) {
                this.props.getProduct(productId, this.props.branchId);
            }
        }

        if (prevProps.productSupplier !== this.props.productSupplier && this.props.productSupplier.length > 0) {
            this.setState({ productSuppliers: this.props.productSupplier });
        }
    }

    componentWillUnmount = () => {
        this.props.init(pageName);
        if (this.ws) {
            this.ws.close();
        }
        this.props.clearFormInput('CalcTaxRateGST');
        this.props.clearFormInput('CalcTaxRatePST');
        this.props.clearFormInput('ManualUPCNumber');
        this.props.clearFormInput(pageName + `WebName`);
        this.props.clearFormInput(pageName + `SubCategoryName`);
        this.props.formInput(0, pageName + `DepositAmount`);
        this.props.formInput(false, pageName + `WebmenuDisplayEnabled`);
        this.props.formInput(false, pageName + `DepositEnabled`);
        this.props.formInput("", pageName + `Size`);
        this.props.formInput(`productSuppliers`, []);
        this.props.clearProductTypeList();
    }

    //when Product is saved successfully
    saveSuccess = () => {
        if (!this.props.isDialog) {
            this.callListView();
            this.props.showProductSuccess(this.state.status === "EDIT" ? LOOKUP.product.messages.editedMessage : LOOKUP.product.messages.createdMessage);
        }
    }

    callListView = () => {
        this.props.navigate("/product");
    }

    //when Product is not saved, failure
    saveFailure = () => {
        this.props.showProductError(LOOKUP.product.messages.saveErrorMessage);
    }

    addProduct = () => {
        const p = this.props;
        let product = p.productModel;

        if (p.PST || p.GST) {
            product.UnitPrice = this.calculateTax(product.UnitPrice);
            product.PromotionPRice = this.calculateTax(product.PromotionPrice);
            product.MemberUnitPrice = this.calculateTax(product.MemberUnitPrice);
            product.EliteMemberUnitPrice = this.calculateTax(product.EliteMemberUnitPrice);
        }

        const categoryOptions = (p.productTypes.find(c => (c.id === p.selectedType))) ? p.productTypes.find(c => (c.id === p.selectedType)).categories : null;

        const isSelectTypeCategory = (categoryOptions) ? categoryOptions.map((cat) => {
            return (cat.id === product.CategoryId) ? true : false;
        }) : false;

        const validators = [
            [pageName + 'Name', product => (product.Name !== null && product.Name !== ""), 'Name'],
            [pageName + 'TypeId', product => product.TypeId > 0, "Type"],
            [pageName + 'CategoryId', product => (isSelectTypeCategory && product.CategoryId > 0), "Category"],
        ];

        product.productSupplier = this.state.productSuppliers;
        [pageName + 'WebName', product => product.WebName, 'WebName'];
        [pageName + 'Size', product => product.Size, 'Size'];
        [pageName + 'SubCategoryName', product => product.SubCategoryName, 'SubCategoryName'];

        if (p.selectedType) {
            const selectedType = p.productTypes.filter(item => item.id == p.selectedType)[0];

            switch (selectedType.measurementType) {
                case MeasurementType.Gram: {
                    validators.push([pageName + 'PriceMatrixId', product => product.PriceMatrixId > 0, "Price Matrix"]);
                    break;
                }
                case MeasurementType.GramUnit: {
                    validators.push([pageName + 'WeightPerUnit', product => product.WeightPerUnit !== null, "Weight Per One Unit"]);
                    validators.push([pageName + 'PriceMatrixId', product => product.PriceMatrixId > 0, "Price Matrix"]);
                    break;
                }
                default:
                    break;
            }
        }
        if (product.CannabisSpecies === "") {
            delete product.CannabisSpecies;
        }
        if (util.validate(validators, product, this.props.formError)) {
            this.props.saveProduct(product);

            if (this.props.closeDialog) {
                this.props.closeDialog();
            }
        }

    }

    loadList = (vendors) => {
        let list = [];
        vendors.map((vendor) => {
            list.push(
                { text: vendor.Name, value: vendor.Name }
            );
        });
        return list;
    }

    initWebSocket = () => {
        try {
            this.ws = new WebSocket("ws://127.0.0.1:5000/");
            this.ws.binaryType = "arraybuffer";

            this.ws.onopen = function () {
                if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                }
            };

            this.ws.onerror = () => {
            };

            this.ws.onclose = (event) => {
                if (event.code !== 99999) {
                }
            };

            this.ws.onmessage = (event) => {
                let response = event.data;
                let content = response.split(',');
                let responseType = content[0];
                let value = content[1];

                if (responseType === "LABELPRINTER") {
                    if (value === 'OFFLINE') {
                        this.props.showError("The label printer is offline. Please, Contact the support team.");
                    }
                }

            };

            window.onbeforeunload = function () {
                if (this.ws) {
                    const model = {
                        Command: "CLOSE",
                        Data: null
                    };

                    this.ws.send(JSON.stringify(model));
                    this.ws.close(99999);
                    window.productWebSocket = null;
                }
            };

            window.productWebSocket = this.ws;
        }
        catch (err) {
            console.error(err);
        }
    }

    calculateTax = (price) => {
        if (this.props.GST && !!this.props.PST === false) {
            const { rate } = this.props.taxes.filter(t => t.name === "GST")[0];

            return (price * (100 / (100 + (rate * 100)).toFixed(4))).toFixed(2);
        }

        if (this.props.PST && !!this.props.GST === false) {
            const { rate } = this.props.taxes.filter(t => t.name === "PST")[0];

            return (price * (100 / (100 + (rate * 100)).toFixed(4))).toFixed(2);
        }

        if (this.props.PST && this.props.GST) {
            const pst = Math.round(this.props.taxes.filter(t => t.name === "PST")[0].rate * 100);
            const gst = Math.round(this.props.taxes.filter(t => t.name === "GST")[0].rate * 100);

            return (price * (100 / (100 + (gst + pst))).toFixed(4)).toFixed(2);
        }
    }

    handleChange = (value) => {
        this.setState({
            value: value
        });
    };

    openCategoryForm = () => {
        this.setState({ categoryDialogOpen: true });
    };

    openEditUPCForm = () => {
        this.setState({ editUPCDialogOpen: true });
    }

    openManualUPCForm = () => {
        this.setState({ manualUPCDialogOpen: true });
    }

    closeCategoryForm = () => {
        this.setState({ categoryDialogOpen: false });
    };

    closeEditUPCForm = () => {
        this.setState({ editUPCDialogOpen: false });
    }

    handleKeyDown = (e) => {
        if (
            e.key === 'ArrowUp' ||
            e.key === 'ArrowDown' ||
            e.key === 'PageUp' ||
            e.key === 'PageDown' ||
            e.key === 'End' ||
            e.key === 'Home'
        ) {
            e.preventDefault();
        }
    }

    mapSKUMapping = (productSupplier) => {
        return (productSupplier || []).filter(item => !item.isDeleted).map(item => {
            let wholeSaleInput = () => {
                return (
                    <div style={{ marginLeft: 5, marginRight: 5 }}>
                        <DecimalInputProductSKU
                            type='text'
                            name={`${item.id}wholeSale`}
                            value={item.wholeSale}
                            placeholder={"0"}
                            onKeyDown={this.handleKeyDown}
                            onWheel={event => event.currentTarget.blur()}
                        />
                    </div>
                )
            }

            const model = {
                SupplierProductCode: item.supplierProductCode,
                CaseQty: item.caseQty,
                SupplierName: item.supplierName,
                WholeSale: wholeSaleInput(),
                IconDelete: (<Button
                    mini={true}
                    type="IconDelete"
                    className="glyphicon-remove-circle"
                    onTouchTap={() => this.deleteProductSKU(item)}
                />),
                ProvinceCode: item.provinceCode,
            }
            return model;
        })
    }

    deleteProductSKU = (model) => {
        const newProductSupplier = this.props.productSupplier && this.props.productSupplier.map(item =>
            item.id === model.id ? { ...item, isDeleted: true } : item
        );
        this.props.formInput(newProductSupplier, "productSupplier")
    }

    closeManualUPCForm = () => {
        this.setState({ manualUPCDialogOpen: false });
    }

    updateUPCFromCatalog = () => {
        let model = {
            BranchId: this.props.branchId,
            ProductId: this.props.params ? Number(this.props.params.id) : 0,
            UPC: "",
            LotNumber: "",
            ChangeOldtoInvalid: true,
            UPCOnly: true,
            UpdateFromCatalog: true
        };
        this.props.editUPC(model);
    }

    manageMoods = () => {
        this.setState({ manageMoodsDialogOpen: true });
    }

    closeMoodsDialog = () => {
        this.setState({ manageMoodsDialogOpen: false });
    }

    manageTerpenes = () => {
        this.setState({ manageTerpenesDialogOpen: true });
    }

    closeTerpeneDialog = () => {
        this.setState({ manageTerpenesDialogOpen: false });
    }

    manageMinorCanabinoid = () => {
        this.setState({ manageMinorCanabinoidsDialogOpen: true });
    }

    closeMinorCanabinoidDialog() {
        this.setState({ manageMinorCanabinoidsDialogOpen: false });
    }

    render() {
        const p = this.props;
        const { productSuppliers } = this.state;

        const breadCrumbPage = this.state.status === 'EDIT' ? productEditCrumb : productAddCrumb

        const priceMatrices = (p.priceMatrices || []).map((item) => {
            return {
                text: item.name,
                value: item.id
            };
        });

        const isDialog = p.isDialog || false;

        const types = p.productTypes.map((item) => {
            return {
                text: item.name,
                value: item.id
            };
        });

        const selectedType = p.productTypes.filter(item => item.id == p.selectedType)[0];

        const categoryOptions = (p.selectedType && types && p.productTypes.find(c => (c.id === p.selectedType))) ?
            p.productTypes.find(c => (c.id === p.selectedType)).categories.map((item) => {
                return {
                    text: item.name,
                    value: item.id
                };
            }).sort((a, b) => {
                if (a.text < b.text)
                    return -1;
                if (a.text > b.text)
                    return 1;
                return 0;
            }) : [{
                text: 'Please Select a Type First',
                value: 0
            }];

        const weightData = p.weightSettings ? { weightSettings: [...p.weightSettings], id: p.productModel.Id } : [];

        let disableCategoryUpdate = false;
        let removeUPCUpdate = false;
        let lowerCaseProvince = (p.provinceState || "").toLowerCase();
        if (!p.isVape && !p.isMedical && this.state.status === 'EDIT' && p.isCannabis && (lowerCaseProvince == "bc" || lowerCaseProvince == "british columbia" || lowerCaseProvince == "mb" || lowerCaseProvince == "manitoba")) {
            disableCategoryUpdate = true;
        }

        if (lowerCaseProvince == "on" || lowerCaseProvince == "ontario") {
            removeUPCUpdate = true;
        }

        let dialogClass = p.isDialog ? "col-log-12 ml-3 mr-3" : "col-sm-6 mb-2";

        let uom = "%";
        if (LOOKUP.productCategory.unitOfMeasurement.find(x => x.value == p.uom)) uom = LOOKUP.productCategory.unitOfMeasurement.find(x => x.value == p.uom).text;

        const filteredSpecies = p.isVape ? [7, 8, 9, 10, 11] : [1, 2, 3, 4, 5, 6];

        return (
            <React.Fragment>
                <Grid headerContent={breadCrumbPage}>
                    <div className="row editPage">
                        {/* LEFT PANEL */}
                        <section className="col-xs-12 col-sm-4 pt-3">
                            <div className='row'>
                                <div className="col-xs-12">
                                    <TextInput
                                        name={`${pageName}SKU`}
                                        fullWidth={true}
                                        label={LOOKUP.product.sku.label}
                                        floatingLabelText={LOOKUP.product.sku.label}
                                        hintText={LOOKUP.product.sku.hintText}
                                        maxLength={50}
                                        disabled={this.state.status === 'EDIT' && p.isCannabis} />
                                </div>
                                {this.state.status !== 'EDIT' ?
                                    <div className="col-xs-12">
                                        {p.manualUPCValue &&
                                            <TextInput
                                                name={`${pageName}manualUPC`}
                                                fullWidth={true}
                                                floatingLabelText={`UPC: ${p.manualUPCValue}`}
                                                disabled={true} />}
                                        <Button name="RaisedButton"
                                            className="pull-left mb-3"
                                            primary={true}
                                            onTouchTap={this.openManualUPCForm}
                                            label="Manual Input UPC" />
                                    </div>
                                    : ""}
                                {this.state.status == "EDIT" && p.productModel.TypeId == 2 ?
                                    <React.Fragment>
                                        <div className="col-xs-12 mb-3">
                                            <TextInput
                                                name={`${pageName}UPC`}
                                                fullWidth={true}
                                                label={LOOKUP.product.upc.label}
                                                floatingLabelText={LOOKUP.product.upc.label}
                                                hintText={LOOKUP.product.upc.hintText}
                                                maxLength={100}
                                                disabled={true} />
                                        </div>
                                        {!p.isVape &&
                                            <ToggleButtonsGroup
                                                mainButtonStyle={{ width: "202px", backgroupColor: "rgb(122, 96, 229)" }}
                                                containerStyle={{ width: "100%", padding: "0 3px 10px" }} sku={p.productSKU} />}
                                        {((!p.crossProvincesMerchant && !removeUPCUpdate) || !p.isCannabis) &&
                                            <div className="col-xs-12 mb-3">
                                                <Button name="RaisedButton"
                                                    className="pull-left"
                                                    primary={true}
                                                    onTouchTap={this.openEditUPCForm}
                                                    label="Add/Edit UPC" />
                                            </div>
                                        }
                                        {!p.isVape && p.isCannabis &&
                                            <div className="col-xs-12 mb-3">
                                                <Button name="RaisedButton"
                                                    className="pull-left"
                                                    primary={true}
                                                    onTouchTap={this.updateUPCFromCatalog}
                                                    label="Sync UPC From Catalog" />
                                            </div>
                                        }

                                    </React.Fragment> : null
                                }
                                <div className="col-xs-12 mb-3">
                                    <ImageUpload name={`${pageName}ImageURL`} />
                                </div>
                                {p.params && p.params.id && <div className="col-xs-12 mb-3">
                                    <MultipleImageUpload />
                                </div>}
                                {
                                    !p.isVape && p.isCannabis && p.params && p.params.id &&
                                    <React.Fragment>
                                        <div className="col-xs-12 mb-3">
                                            <Button
                                                name="RaisedButton"
                                                className="pull-left"
                                                primary={true}
                                                onTouchTap={this.manageTerpenes}
                                                label="Manage Terpenes" />
                                        </div>
                                        <div className="col-xs-12 mb-3">
                                            <Button
                                                name="RaisedButton"
                                                className="pull-left"
                                                primary={true}
                                                onTouchTap={this.manageMoods}
                                                label="Manage Moods" />
                                        </div>
                                        <div className="col-xs-12 mb-3">
                                            <Button
                                                name="RaisedButton"
                                                className="pull-left"
                                                primary={true}
                                                onTouchTap={this.manageMinorCanabinoid}
                                                label="Manage Minor Canabinoids" />
                                        </div>
                                    </React.Fragment>
                                }
                            </div>
                        </section>

                        {/* RIGHT PANEL */}
                        <section className="col-xs-12 col-sm-8 p-3 editInfo">
                            <div className="row">
                                <div className="col-sm-6">
                                    <h4 className="profile-view-subtitle">Product Information</h4>
                                </div>
                                <div className="col-xs-12 col-sm-6 pt-3">
                                    <ToggleInput className="toggle-active-inactive btnToggleLabel" labelPlacement="end" name={`${pageName}Status`} label={LOOKUP.product.status.label} text="Inactive" text2="Active" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <TextInput
                                        name={`${pageName}Name`}
                                        fullWidth={true}
                                        label={LOOKUP.product.name.label}
                                        floatingLabelText={LOOKUP.product.name.label}
                                        hintText={LOOKUP.product.name.hintText}
                                        required />
                                </div>
                                <div className="col-sm-6">
                                    {p.isLegal && !p.isMedical ?
                                        <SelectInput
                                            name={`${pageName}TypeId`}
                                            id="productType"
                                            fullWidth={true}
                                            label={LOOKUP.product.type.label}
                                            floatingLabelText={LOOKUP.product.type.label}
                                            options={types.filter(item => item.value === 2)}
                                            hintText={LOOKUP.product.type.hintText}
                                            disabled={true}
                                            defaultValue={2}
                                        />
                                        :
                                        <SelectInput
                                            name={`${pageName}TypeId`}
                                            id="productType"
                                            fullWidth={true}
                                            label={LOOKUP.product.type.label}
                                            floatingLabelText={LOOKUP.product.type.label}
                                            options={types}
                                            hintText={LOOKUP.product.type.hintText}
                                            required
                                        />
                                    }

                                </div>
                            </div>
                            <div className="row">
                                <div className={dialogClass}>
                                    <TextInput
                                        name={`${pageName}WebName`}
                                        fullWidth
                                        label={LOOKUP.product.webName.label}
                                        floatingLabelText={LOOKUP.product.webName.label}
                                        hintText={LOOKUP.product.webName.hintText}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <SelectInput
                                        name={`${pageName}CategoryId`}
                                        id="productCategory"
                                        fullWidth={true}
                                        label={LOOKUP.product.category.label}
                                        floatingLabelText={LOOKUP.product.category.label}
                                        options={categoryOptions}
                                        hintText={LOOKUP.product.category.hintText}
                                        disabled={disableCategoryUpdate}
                                        required
                                    />
                                    {(!isDialog) &&
                                        <Link
                                            className="link-new-above"
                                            onClick={this.openCategoryForm}>Create new Category
                                        </Link>
                                    }
                                </div>
                                {p.isCannabis &&
                                    <div className={dialogClass}>
                                        <SelectInput
                                            name={`${pageName}CannabisSpecies`}
                                            fullWidth={true}
                                            label={p.isVape ? "Variant" : "Species"}
                                            floatingLabelText={p.isVape ? "Variant" : "Species"}
                                            options={LOOKUP.intSpecies.filter((species) => filteredSpecies.includes(species.value))}
                                            hintText={LOOKUP.product.category.hintText}
                                        />
                                    </div>
                                }
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <TextInput
                                        name={`${pageName}SubCategoryName`}
                                        fullWidth={true}
                                        label={LOOKUP.product.subCategory.label}
                                        floatingLabelText={LOOKUP.product.subCategory.label}
                                        hintText={LOOKUP.product.subCategory.hintText}
                                    />
                                </div>
                            </div>
                            {(selectedType && selectedType.measurementType == 3 || selectedType && selectedType.measurementType == 2) &&
                                (this.state.weightInOneUnitShowing) && (
                                    <div className="row">
                                        <Col lg={6} xs={6} >
                                            <DecimalInput name={`${pageName}WeightPerUnit`}
                                                hintText={'Amount'}
                                                min={0}
                                                max={1000000}
                                                label="How much Weight in ONE unit(g or ml):" />
                                        </Col>

                                    </div>
                                )
                            }
                            {
                                (selectedType && selectedType.measurementType == 2) &&
                                (
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <DecimalInput
                                                name={`${pageName}UnitPrice`}
                                                id='productUnitPrice'
                                                min={0}
                                                max={1000000}
                                                required
                                                label="Selling Price"
                                            />
                                        </div>
                                        {this.state.status === 'EDIT' ? (
                                            <div className="col-lg-6 p-0">
                                                <div className="row">
                                                    <Col lg={6} xs={6} >  <DecimalInput
                                                        name={`${pageName}LatestBaseCost`}
                                                        label="Latest Base Cost"
                                                        disabled={true}
                                                        fullWidth={true}
                                                        floatingLabelText="Latest Base Cost"
                                                    />
                                                    </Col>
                                                    <Col lg={6} xs={6} >    <DecimalInput
                                                        name={`${pageName}BaseCost`}
                                                        label="Average Base Cost"
                                                        disabled={true}
                                                        fullWidth={true}
                                                        floatingLabelText="Average Base Cost"
                                                    />
                                                    </Col>

                                                </div>
                                            </div>) : null}
                                        <div className="col-lg-6">
                                            <DecimalInput
                                                name={`${pageName}PromotionUnitPrice`}
                                                label={LOOKUP.product.promotionUnitPrice.label}
                                                min={0}
                                                max={1000000}
                                                required
                                                fullWidth={true}
                                                floatingLabelText="Promotion Price"
                                                disabled={!(this.props.isHighTide || this.props.isInspired)}
                                            />
                                        </div>
                                        {(p.memberEnabled) && (
                                            <div className="col-lg-6">
                                                <DecimalInput
                                                    name={`${pageName}MemberUnitPrice`}
                                                    fullWidth={true}
                                                    floatingLabelText="Member Price"
                                                    label={LOOKUP.product.memberUnitPrice.label}
                                                    min={0}
                                                    max={1000000}
                                                    required />
                                            </div>
                                        )}
                                        <div className="col-lg-6">
                                            <TextInput
                                                name={`${pageName}Size`}
                                                fullWidth
                                                label={LOOKUP.product.size.label}
                                                floatingLabelText={LOOKUP.product.size.label}
                                                hintText={LOOKUP.product.size.hintText}
                                            />
                                        </div>
                                        {
                                            this.props.isHighTide &&
                                            <div className="col-lg-6">
                                                <DecimalInput
                                                    name={`${pageName}EliteMemberUnitPrice`}
                                                    label={LOOKUP.product.eliteMemberUnitPrice.label}
                                                    min={0}
                                                    max={1000000}
                                                    required
                                                    fullWidth={true}
                                                    floatingLabelText="Elite Member Price"
                                                />
                                            </div>
                                        }
                                        <div className="row">
                                            <div className="col-lg-6">
                                                {
                                                    (selectedType && selectedType.measurementType == 2 && p.isCannabis && !p.isVape) &&
                                                    <DecimalInput
                                                        name={`${pageName}dfe`}
                                                        floatingLabelText={LOOKUP.product.dfe.hintText}
                                                        label={LOOKUP.product.dfe.label}
                                                        fullWidth={true}
                                                        min={0}
                                                        max={1000000}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            {
                                this.props.isHighTide &&
                                <div className="row mt-2">
                                    <div className="col-xs-12 col-sm-6">
                                        <ToggleInput className="toggle-yes-no btnToggleLabel" name={`${pageName}IsElite`} label={LOOKUP.product.isElite.label} option1="No" option2="Yes" />
                                    </div>
                                </div>
                            }
                            <div className="row">
                                <div className="col-xs-12 col-sm-6">
                                    <ToggleInput className="toggle-yes-no btnToggleLabel" name={`${pageName}DepositEnabled`} label={LOOKUP.product.depositEnabled.label} option1="No" option2="Yes" disabled={!this.props.canEditDepositAmount} />
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <ToggleInput className="toggle-yes-no btnToggleLabel" name={`${pageName}WebmenuDisplayEnabled`} label={LOOKUP.product.webmenuDisplayedEnabled.label} option1="No" option2="Yes" />
                                </div>
                                <div className="col-xs-12 col-sm-6 mt_-20">
                                    {
                                        (p.depositEnabled) &&
                                        <DecimalInput
                                            name={`${pageName}DepositAmount`}
                                            label={LOOKUP.product.depositAmount.hintText}
                                            min={0}
                                            max={1000000}
                                            required
                                            disabled={!this.props.canEditDepositAmount} />
                                    }
                                </div>
                                <div className="col-lg-12">
                                    <TextInput
                                        name={`${pageName}Brand`}
                                        label={LOOKUP.product.brand.label}
                                        floatingLabelText={LOOKUP.product.brand.label}
                                        hintText={LOOKUP.product.brand.hintText}
                                        fullWidth
                                        maxLength={1000}
                                    />
                                </div>
                            </div>
                            {
                                !p.isVape && p.isCannabis &&
                                <div className="row">
                                    <div className="col-xs-6 col-lg-4">
                                        <DecimalInput
                                            name={`${pageName}THCMin`}
                                            label={LOOKUP.product.thcmin.label + "(" + uom + ")"}
                                            disabled={false}
                                            fullWidth
                                            floatingLabelText={LOOKUP.product.thcmin.label + "(" + uom + ")"}
                                        />
                                    </div>
                                    <div className="col-xs-6 col-lg-4">
                                        <DecimalInput
                                            name={`${pageName}THCMax`}
                                            label={LOOKUP.product.thcmax.label + "(" + uom + ")"}
                                            disabled={false}
                                            fullWidth
                                            floatingLabelText={LOOKUP.product.thcmax.label + "(" + uom + ")"}
                                        />
                                    </div>
                                    <div className="col-xs-6 col-lg-4">
                                        <DecimalInput
                                            name={`${pageName}THC`}
                                            label={LOOKUP.product.thc.label + "(" + uom + ")"}
                                            disabled={true}
                                            fullWidth
                                            floatingLabelText={LOOKUP.product.thc.label + "(" + uom + ")"}
                                        />
                                    </div>
                                    <div className="col-xs-6 col-lg-4">
                                        <DecimalInput
                                            name={`${pageName}CBDMin`}
                                            label={LOOKUP.product.cbdmin.label + "(" + uom + ")"}
                                            disabled={false}
                                            fullWidth
                                            floatingLabelText={LOOKUP.product.cbdmin.label + "(" + uom + ")"}
                                        />
                                    </div>
                                    <div className="col-xs-6 col-lg-4">
                                        <DecimalInput
                                            name={`${pageName}CBDMax`}
                                            label={LOOKUP.product.cbdmax.label + "(" + uom + ")"}
                                            disabled={false}
                                            fullWidth={true}
                                            floatingLabelText={LOOKUP.product.cbdmax.label + "(" + uom + ")"}
                                        />
                                    </div>
                                    <div className="col-xs-6 col-lg-4">
                                        <DecimalInput
                                            name={`${pageName}CBD`}
                                            label={LOOKUP.product.cbd.label + "(" + uom + ")"}
                                            disabled={true}
                                            fullWidth
                                            floatingLabelText={LOOKUP.product.cbd.label + "(" + uom + ")"}
                                        />
                                    </div>
                                    <p>Note: THC/CBD Exact Levels: this is the default value entered from the latest PO received</p>
                                </div>
                            }
                            <div className="row" style={{ marginTop: 12 }}>
                                <div className="col-xs-12">
                                    <TextInput
                                        name={`${pageName}Description`}
                                        label={LOOKUP.product.description.label}
                                        floatingLabelText={LOOKUP.product.description.label}
                                        hintText={LOOKUP.product.description.hintText}
                                        fullWidth
                                        maxLength={1000}
                                    />
                                </div>
                            </div>
                            {
                                productSuppliers.length > 0 &&
                                <div className="row" style={{ marginTop: 12 }}>
                                    <div className="col-xs-12">
                                        <h4 className='bold'> SKU Mapping Information </h4>
                                        <div className="product-content list-table">
                                            {<CardSimple>
                                                <GenericTable
                                                    className="table_center"
                                                    multiSelectable={false}
                                                    enableSelectAll={false}
                                                    displaySelectAll={false}
                                                    adjustForCheckbox={false}
                                                    displayRowCheckbox={false}
                                                    selectable={false}
                                                    stripedRows={true}
                                                    columns={LOOKUP.product.tableSKUMappingForUpdate}
                                                    rows={this.mapSKUMapping(p.productSupplier)}
                                                />
                                            </CardSimple>}
                                        </div>
                                    </div>
                                </div>
                            }
                            <br />
                            {/* Buttons */}
                            <div className="row">
                                <div className="col-xs-12">
                                    <Button
                                        name="saveButton"
                                        className="pull-right btnNewBrandPOS"
                                        label={LOOKUP.product.controls.saveButton}
                                        primary={true}
                                        onTouchTap={this.addProduct} />
                                    <Button
                                        type="CancelButton"
                                        name="buttonCancel"
                                        className="pull-right btn-space btnCancelOperation"
                                        label={LOOKUP.product.controls.cancelButton}
                                        onTouchTap={p.closeDialog ? p.closeDialog : this.callListView} />
                                </div>
                            </div>
                        </section>

                        {/* PRICE MATRIX PANEL */}
                        <section className="col-xs-12">
                            {selectedType ?
                                <div>
                                    {selectedType.measurementType == 2 ?
                                        <div></div> :
                                        <div className="form-group border-top-purple p-2">
                                            <h4 className="profile-view-subtitle">Price Matrix Information</h4>
                                            <div className="row">
                                                <div className="col-xs-12">
                                                    <SelectInput name={`${pageName}PriceMatrixId`}
                                                        label={LOOKUP.product.priceMatrix.label}
                                                        options={priceMatrices}
                                                        hintText={LOOKUP.product.priceMatrix.hintText} />
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-xs-12">
                                                    {
                                                        this.state.status == "EDIT"
                                                            ?
                                                            <PriceMatrixMeasurementTable
                                                                readonly={true}
                                                                hideEmpty={true}
                                                                name={`${pageName}PriceMatrixTableDetails`}
                                                                productName={p.productModel.Name}
                                                                measurementSettings={weightData.weightSettings || []}
                                                                productId={weightData.id}
                                                                ws={this.ws}
                                                                isMedical={p.isMedical}
                                                            />
                                                            :
                                                            <PriceMatrixMeasurementTable
                                                                readonly={true}
                                                                hideEmpty={true}
                                                                name={`${pageName}PriceMatrixTableDetails`}
                                                                productName={p.productModel.Name}
                                                                measurementSettings={weightData.weightSettings || []}
                                                                productId={weightData.id}
                                                                ws={this.ws}
                                                                notPrintLabel={true}
                                                                isMedical={p.isMedical}
                                                            />
                                                    }
                                                </div>
                                            </div>
                                            {/* Buttons */}
                                            {selectedType.measurementType == 1 || selectedType && selectedType.measurementType == 3 ? (
                                                <div className="row">
                                                    <div className="col-xs-12">
                                                        <Button
                                                            name="saveButton"
                                                            className="pull-right btnNewBrandPOS"
                                                            label={LOOKUP.product.controls.saveButton}
                                                            primary={true}
                                                            onTouchTap={this.addProduct} />
                                                        <Button
                                                            type="CancelButton"
                                                            name="buttonCancel"
                                                            className="pull-right btn-space btnCancelOperation"
                                                            primary={true}
                                                            label={LOOKUP.product.controls.cancelButton}
                                                            onTouchTap={p.closeDialog ? p.closeDialog : this.callListView} />
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                    }
                                </div> : null
                            }
                        </section>
                    </div>
                </Grid>
                <DialogInput
                    title={<DialogHeaderWithClose text="Create a New Category" classicClass="posDialogClassic" handleClose={() => this.closeCategoryForm()} />}
                    modal={true}
                    open={this.state.categoryDialogOpen}
                    autoScrollBodyContent={true}
                    className="transfer_Product checkIn_list memberDialogPOSScreen"
                    handleClose={() => this.closeCategoryForm()}
                    contentStyle={customContentStyle}>
                    <br />

                    <Button name="buttonCancel"
                        type="Button"
                        className="corner_X"
                        label=""
                        onTouchTap={() => this.closeCategoryForm()}
                    />
                    <div className="no-crumb">
                        <ProductCategorySave
                            name="dialogCategory"
                            isDialog={true}
                            onCancel={() => this.closeCategoryForm()}
                        />
                    </div>
                </DialogInput>
                <DialogInput
                    title={<DialogHeaderWithClose text={"ADD/EDIT UPC For Product: " + p.productModel.Name} classicClass="posDialogClassic" handleClose={() => this.closeEditUPCForm()} />}
                    className="no_btns_dialog"
                    modal={true}
                    open={this.state.editUPCDialogOpen}
                    autoScrollBodyContent={true}
                >
                    <ProductUPCEdit
                        cancel={this.closeEditUPCForm}
                        productId={p.productModel.Id}
                        isMedical={p.isMedical}
                    />
                </DialogInput>
                <DialogInput
                    title={<DialogHeaderWithClose text={"Manual Input UPC For Product"} classicClass="posDialogClassic" handleClose={() => this.closeManualUPCForm()} />}
                    className="no_btns_dialog"
                    modal={true}
                    open={this.state.manualUPCDialogOpen}
                    autoScrollBodyContent={true}
                >
                    <ProductManualUPC
                        cancel={this.closeManualUPCForm}
                    />
                </DialogInput>
                <MoodDialogInput
                    title="MANAGE MOODS"
                    modal={true}
                    open={this.state.manageMoodsDialogOpen}
                    handleClose={() => this.closeMoodsDialog()}>
                    <div className="no-crumb">
                        <ProductMood
                            name="dialogMood"
                            onCancel={() => this.closeMoodsDialog()}
                            productId={p.params ? p.params.id : undefined}
                            pageName={pageName}
                        />
                    </div>
                </MoodDialogInput>
                <TerpeneDialogInput
                    title="MANAGE TERPENES"
                    modal={true}
                    open={this.state.manageTerpenesDialogOpen}
                    handleClose={() => this.closeTerpeneDialog()}
                >
                    <div className="no-crumb">
                        <ProductTerpene
                            name="dialogTerpene"
                            onCancel={() => this.closeTerpeneDialog()}
                            productId={p.params ? p.params.id : undefined}
                            pageName={pageName}
                        />
                    </div>
                </TerpeneDialogInput>
                <MinorCanabinoidDialogInput
                    title="MANAGE MINOR CANABINOIDS"
                    modal={true}
                    open={this.state.manageMinorCanabinoidsDialogOpen}
                    handleClose={() => this.closeMinorCanabinoidDialog()}>
                    <div className="no-crumb">
                        <ProductMinorCanabinoid
                            name="dialogTerpene"
                            onCancel={() => this.closeMinorCanabinoidDialog()}
                            productId={p.params ? p.params.id : undefined}
                            pageName={pageName}
                        />
                    </div>
                </MinorCanabinoidDialogInput>
            </React.Fragment>
        );
    }
}

function mapStatetoProps(state, props) {
    let checkIsCannabis = false;
    if (state.entity.productTypesList && state.entity.productTypesList.length > 0 && state.form[pageName + "TypeId"] && state.form[pageName + "CategoryId"]) {
        const categories = state.entity.productTypesList.filter(t => t.measurementType === state.form[pageName + "TypeId"])[0].categories;
        if (categories) {
            const filterCategory = categories.filter(x => x.id === state.form[pageName + "CategoryId"]);
            checkIsCannabis = filterCategory && filterCategory.length > 0 ? filterCategory[0].isCannabis : false;
        }
    }
    return {
        store: state.common.store,
        branchId: state.common.branchId,
        productModel: selectProductModel(state, pageName),
        productTypes: state.entity.productTypesList,
        priceMatrices: state.entity.priceMatricesList,
        weightSettings: state.entity.weightSettingsList,
        formState: state.form,
        selectedType: state.form[pageName + "TypeId"],
        saveSuccess: state.form[pageName + "SaveSuccess"],
        depositEnabled: state.form[pageName + "DepositEnabled"],
        printQuantity: state.form.labelQuantityProductBarcode,
        unitPrice: state.form.productSaveUnitPrice,
        promotionUnitPrice: state.form.productSavePromotionUnitPrice,
        memberUnitPrice: state.form.productSaveMemberUnitPrice,
        eliteMemberUnitPrice: state.form.productSaveEliteMemberUnitPrice,
        taxes: state.entity.taxesrateList.filter(t => t.status != 2),
        GST: state.form.CalcTaxRateGST,
        PST: state.form.CalcTaxRatePST,
        isMedical: state.common.applicationSettings.isMedical,
        isVape: state.common.applicationSettings.isVape,
        isLegal: state.common.applicationSettings.isLegal,
        isElite: state.form.ProductSaveIsElite,
        memberEnabled: state.common.applicationSettings.memberEnabled,
        crossProvincesMerchant: state.common.applicationSettings.crossProvincesMerchant,
        isCannabis: checkIsCannabis,
        productGotSuccessKey: state.form.productGotSuccessKey,
        provinceState: state.common.store.provinceState || "",
        syncProductSuccess: state.entity.syncProductsInfoTime,
        uom: state.form[pageName + "UOM"] || 0,
        manualUPCValue: state.form.ManualUPCNumber || "",
        productSupplier: state.form.productSupplier,
        isHighTide: state.common.applicationSettings.isHighTide,
        isInspired: state.common.applicationSettings.isInspired,
        canEditDepositAmount: !state.common.applicationSettings.isHighTide && state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanEditDepositAmount")),
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        saveProduct: (model) => dispatch(saveProduct(model, pageName)),
        init: (name) => dispatch(initializeProductForm(name)),
        showProductSuccess: (message) => dispatch(showSnackbar(message)),
        getProduct: (productId, branchId) => dispatch(getProduct(productId, branchId, pageName)),
        getProductTypes: () => dispatch(getProductTypes()),
        getCategories: () => dispatch(getCategories(parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')))),
        getWeightSettings: () => dispatch(getWeightSettings()),
        getPriceMatrices: () => dispatch(getPriceMatrices()),
        loadProductPriceMatrixTable: (priceMatrix) => dispatch(loadProductPriceMatrixTable(`${pageName}PriceMatrixTable`, priceMatrix)),
        showProductError: (message) => dispatch(showError(message)),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        clearStoreProductForType: () => dispatch(clearStoreProductForType(pageName)),
        clearPrintQuantity: (compName) => dispatch(formInput("", compName)),
        getTaxesRate: () => dispatch(getTaxesRate(1)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        editUPC: (model) => dispatch(editProductUPC(model)),
        clearProductTypeList: () => dispatch(clearProductTypeList())
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(ProductSave));
